export enum EBtnHierarchyType {
    Primary,
    Secondary,
    Tertiary,
    LinkColor,
    LinkGray,
    Close,
    Utility
}